import { render, staticRenderFns } from "./PickUpInfo.vue?vue&type=template&id=71823654&scoped=true"
import script from "./PickUpInfo.vue?vue&type=script&lang=js"
export * from "./PickUpInfo.vue?vue&type=script&lang=js"
import style0 from "./PickUpInfo.vue?vue&type=style&index=0&id=71823654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71823654",
  null
  
)

export default component.exports